import { useState } from "react";
import { featured, columns } from "@/mocks/daily";

export default function Featured() {
  const [col, setCol] = useState("all");
  const list = col === "all" ? featured : featured.filter((a) => a.cat === col);
  const lead = list[0];
  const rest = list.slice(1);

  return (
    <section id="featured" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-widest text-primary-600 uppercase">Editor’s Pick</p>
            <h2 className="mt-2 font-serif text-2xl md:text-4xl font-black text-foreground-950">
              今日<span className="text-primary-500">栏目精选</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">每日整理的原创盘点 · 一键按主题筛选</p>
          </div>
          <div className="inline-flex flex-wrap gap-1.5">
            {columns.map((c) => (
              <button
                key={c.key}
                type="button"
                onClick={() => setCol(c.key)}
                aria-pressed={col === c.key}
                className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                  col === c.key
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300"
                }`}
              >
                {c.label}
                <span className={`ml-1 ${col === c.key ? "text-background-100" : "text-foreground-400"}`}>
                  {col === "all" ? c.count : featured.filter((a) => a.cat === c.label).length}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* 头条精选大卡 */}
        {lead && (
          <article className="group mt-7 grid overflow-hidden rounded-xl bg-background-100 border border-background-200 md:grid-cols-2">
            <div className="relative min-h-52 overflow-hidden md:min-h-72">
              <img
                src={lead.img}
                alt={lead.title}
                title={lead.title}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                头条精选
              </span>
            </div>
            <div className="flex flex-col justify-center p-5 md:p-8">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-primary-600 border border-background-200">
                <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
                {lead.cat} · {lead.tag}
              </span>
              <h3 className="mt-3 font-serif text-xl md:text-2xl font-bold leading-snug text-foreground-950">
                {lead.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:line-clamp-3">{lead.excerpt}</p>
              <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span>{lead.time}</span>
                <span className="h-1 w-1 rounded-full bg-background-300" aria-hidden="true"></span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line text-primary-500" aria-hidden="true"></i>
                  {lead.hot} 次浏览
                </span>
              </div>
            </div>
          </article>
        )}

        {/* 其余卡片 */}
        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-xl bg-background-50 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={a.img}
                  alt={a.title}
                  title={`每日爆料 ${a.title}`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-0.5 text-[11px] text-background-50 backdrop-blur">
                  {a.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="inline-flex w-fit items-center gap-1 text-xs font-semibold text-primary-600">
                  <i className="ri-flashlight-fill text-accent-500" aria-hidden="true"></i>
                  {a.tag}
                </span>
                <h3 className="mt-2 font-serif text-base md:text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {a.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                <div className="mt-auto flex items-center gap-3 pt-4 text-xs text-foreground-500">
                  <span>{a.time}</span>
                  <span className="h-1 w-1 rounded-full bg-background-300" aria-hidden="true"></span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line text-accent-600" aria-hidden="true"></i>
                    {a.hot}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}